import { IHttpApi } from '@cian/http-api';

import { assertResponseError } from './assert';
import {
  fetchCanUserCreateRequest,
  TCanUserCreateRequestResponse,
  TCanUserCreateRequestResponse_1,
} from '../../repositories/newbuilding-broker/v1/can-user-create-request';

interface IParams {
  httpApi: IHttpApi;
}

export const canUserCreateRequest = async ({ httpApi }: IParams): Promise<TCanUserCreateRequestResponse_1> => {
  const result: TCanUserCreateRequestResponse = await fetchCanUserCreateRequest({ httpApi });

  assertResponseError(result);

  return result.response;
};
